import {useTranslation} from 'react-i18next';

import {isFanOutNode} from '../../../config/nodeCategories';
import {recipientStepName} from '../../../config/recipients';
import NodeEditorLayout from '../NodeEditorLayout';
import {NodeEditorV2Props} from '../types';

/** This maintenance action reads no node config; its scope is always the whole organisation. */
const FullSyncAudienceEditorV2 = ({upstreamNodes = []}: NodeEditorV2Props) => {
    const {t} = useTranslation();
    const fanOut = upstreamNodes.find(node => isFanOutNode(node.type));
    const scope = t('Refreshes all active audience sizes and syncs with Maileon when connected. There is nothing to configure here.');

    return (
        <NodeEditorLayout
            state={fanOut ? 'caution' : 'ready'}
            summary={fanOut
                ? `${scope} ${t('After ‘{{step}}’, this organisation-wide sync can repeat for each person. Place it before that step to run it once.', {step: recipientStepName(fanOut)})}`
                : scope}
        />
    );
};

export default FullSyncAudienceEditorV2;
